import api from "./api-manager";

const {
  REACT_APP_RMP_SALESDESK_API_URL,
  REACT_APP_RMP_APP_ID,
  REACT_APP_RMP_DA_API_URL,
  REACT_APP_RCRM_API_URL,
  REACT_APP_RCRM_API_SECRET,
} = process.env;

export default {
  async getAccountHierarchy(token, params) {
    return api.post(
      `/v1/rads/google-api/account/hierarchy`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_id: params.business_id,
        agency_id: params.agency_id,
        adwords_id: params.adwords_id,
        adwords_code: params.adwords_code,
        refresh_token: params.refresh_token,
        adwords_email: params.adwords_email,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async autoLinkAccount(params) {
    return api.post(
      `/v1/rads/google-api/account/autolink`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_id: params.business_id,
        agency_id: params.agency_id,
        adwords_id: params.adwords_id,
        refresh_token: params.refresh_token,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async createOfflineConversion(params) {
    return api.post(
      `/v1/rads/google-api/offlineconversion/create`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_id: params.business_id,
        adwords_id: params.adwords_id,
        agency_id: params.agency_id,
        lead_status_id: params.lead_status_id, // conversions_data
        conversion_name: params.conversion_name, // conversions_data
        conversion_id: params.conversion_id, // conversions_data
        feature_name: params.feature_name, // conversions_data
        lang: params.lang,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getLinkAccountStatus(params) {
    return api.post(
      `/v1/rads/google-api/link/account/status`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_id: params.business_id,
        adwords_id: params.adwords_id,
        skip_update_accept: params.skip_update_accept,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getBusinessInfo(token, params) {
    return api.post(
      `/v1/rads/business/info`,
      {
        app_id: REACT_APP_RMP_APP_ID,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async setBusinessAdwordsId(params) {
    return api.post(
      `/v1/rads/business/update/adwordsid`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_id: params.business_id,
        adwords_id: params.adwords_id,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async setBusinessAdwordsName(params) {
    return api.post(
      `/v1/rads/business/update/adwordsname`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_id: params.business_id,
        adwords_name: params.adwords_name,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async setBusinessCanAccess(params) {
    return api.post(
      `/v1/rads/business/update/canaccess`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        can_access_adwords: params.can_access_adwords,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async setRwidgetConversionDefaultValue(params) {
    return api.post(
      `/v1/rads/rwidget-conversions/default-value`,
      {
        ...params,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getAdwordsConversionsData(params) {
    return api.post(
      `/v1/rads/adwords/get/conversionsdata`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_plan: params.business_plan,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getAdwordsConversionsLastsend(params) {
    return api.post(
      `/v1/rads/adwords/conversions/lastsend`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        lang: params.lang,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getAccountData(params) {
    return api.post(
      `/v1/rads/google-api/account/data`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_id: params.business_id,
        adwords_id: params.adwords_id,
        agency_id: params.agency_id,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getBusinessPipelines(params) {
    return api.post(
      `/v1/rads/business/pipeline/list`,
      {
        app_id: REACT_APP_RMP_APP_ID,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getBusinessSteps(params) {
    return api.post(
      `/v1/rads/business/step/list`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        lead_pipeline_id: params.lead_pipeline_id,
        lang: params.lang,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getAdwordsPipelineConversionsData(params) {
    return api.post(
      `/v1/rads/adwords/get/conversionsdata/lead-pipeline`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        lead_pipeline_id: params.lead_pipeline_id,
        lead_pipeline_default_value: params.lead_pipeline_default_value,
        conversion_set: params.conversion_set,
        status: params.status,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async createAdwordsPipelineConversionsData(params) {
    return api.post(
      `/v1/rads/adwords/create`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        adwords_id: params.adwords_id,
        agency_id: params.agency_id,
        lead_status_id: params.lead_status_id,
        conversion_name: params.conversion_name,
        conversion_value: params.conversion_value,
        conversion_id: params.conversion_id,
        feature_name: params.feature_name,
        lang: params.lang,
        lead_pipeline_id: params.lead_pipeline_id,
        business_id: params.business_id,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getOfflineConversionAddon(params) {
    return api.post(
      `/v1/rads/business/get/conversions/addon`,
      {
        app_id: REACT_APP_RMP_APP_ID,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async updateOfflineConversionAddon(params) {
    return api.post(
      `/v1/rads/business/update/conversions/addon`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        smart_ads_status: params.smartAdsStatus,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getFacebookApiToken(params) {
    return api.post(
      `/v1/rads/facebook-api/get-access-token-expires-facebook-api`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        access_token: params.access_token,
      },
      {
        baseURL: REACT_APP_RMP_DA_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getFacebookBusinessList(params) {
    return api.post(
      `/v1/rads/facebook-api/business/detail`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        user_id: params.user_id,
        user_access_token: params.user_access_token,
      },
      {
        baseURL: REACT_APP_RMP_DA_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getFacebookPixelCodeList(params) {
    return api.post(
      `/v1/rads/facebook-api/ad-account/pixel`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        ads_account_id: params.ads_account_id,
        user_access_token: params.user_access_token,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getFacebookAdsAccountList(params) {
    return api.post(
      `/v1/rads/facebook-api/ad-account/owned-ad-account`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        business_manage_id: params.business_manage_id,
        custom_fields: ["id", "name", "account_id", "currency", "funding_source"],
        user_access_token: params.user_access_token,
      },
      {
        baseURL: REACT_APP_RMP_DA_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async inviteFacebookAdsAccount(params) {
    return api.post(
      `/v1/rads/facebook-api/ad-account/invite-user`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        ads_account_id: params.ads_account_id,
        user_access_token: params.user_access_token,
      },
      {
        baseURL: REACT_APP_RMP_DA_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async inviteFacebookPixels(params) {
    return api.post(
      `/v1/rads/facebook-api/pixels/invite-user`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        pixels_id: params.pixels_id,
        user_access_token: params.user_access_token,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getFacebookDaSettings(params) {
    return api.post(
      `/v1/business/fb-details`,
      {
        app_id: REACT_APP_RMP_APP_ID,
      },
      {
        baseURL: REACT_APP_RMP_DA_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getFacebookPixelAgencies(params) {
    return api.post(
      `/v1/rads/facebook-api/pixels/get-agency`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        pixels_id: params.pixels_id,
        ads_account_id: params.ads_account_id,
        user_access_token: params.user_access_token,
      },
      {
        baseURL: REACT_APP_RMP_DA_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getFacebookAdsAccountAgencies(params) {
    return api.post(
      `/v1/rads/facebook-api/ad-account/get-agencies`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        ads_account_id: params.ads_account_id,
      },
      {
        baseURL: REACT_APP_RMP_DA_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async syncFacebookSettingWithRdynamic(params) {
    return api.post(
      `/v1/rads/facebook/update-select-business-setting`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        fb_ad_business_id: params.fbBusinessId,
        fb_ad_account_id: params.fbAdsId,
        fb_ad_business_name: params.fbBusinessName,
        fb_ad_account_name: params.fbAdsName,
        fb_ad_pixel_code_id: params.fbPixelCodeId,
      },
      {
        baseURL: REACT_APP_RMP_DA_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async syncFacebookSettingWithRmp(params) {
    return api.post(
      `/v1/rads/business/update/facebook`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        fb_ad_account_id: params.fbAdsId,
        fb_ad_account_name: params.fbAdsName,
      },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
};
